var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 305,
    viewBox: "0 0 362 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_91)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 33.98C0 15.21 15.21 0 33.98 0H327.02C345.79 0 361 15.21 361 33.98V270.02C361 288.79 345.79 304 327.02 304H33.98C15.21 304 0 288.79 0 270.02V33.98Z",
    fill: "#99D3CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.51 11.0601C341.69 11.0601 349.95 19.31 349.95 29.48V274.54C349.95 284.72 341.69 292.96 331.51 292.96H29.51C19.33 292.96 11.0699 284.72 11.0699 274.54V29.48C11.0699 19.31 19.33 11.0601 29.51 11.0601H331.51ZM331.51 0.0100098H29.51C13.22 0.0100098 0.0100098 13.2 0.0100098 29.48V274.54C0.0100098 290.82 13.22 304.01 29.51 304.01H331.51C347.8 304.01 361.01 290.82 361.01 274.54V29.48C361.01 13.2 347.8 0.0100098 331.51 0.0100098Z",
    fill: "#99D3CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.01 12.01L89.01 12.08L89.3 51.01L128.01 12.01Z",
    fill: "#F5F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.01 12.01H29.11C19.52 13.29 12.26 21.43 12.01 31.21L12.45 89.01L88.01 12.01Z",
    fill: "#F5F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.01 12.01L128.01 12.05L128.19 31.01L148.01 12.01Z",
    fill: "#F5F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.287 200.486H165.895C165.823 196.548 165.787 194.148 165.787 193.289C165.787 184.409 167.255 177.104 170.191 171.375C173.128 165.646 179 159.201 187.809 152.039C196.617 144.878 201.881 140.187 203.6 137.967C206.249 134.458 207.574 130.59 207.574 126.365C207.574 120.493 205.211 115.48 200.484 111.326C195.829 107.101 189.527 104.988 181.578 104.988C173.915 104.988 167.506 107.173 162.35 111.541C157.193 115.91 153.648 122.57 151.715 131.521L124 128.084C124.788 115.265 130.23 104.38 140.328 95.4277C150.497 86.4759 163.818 82 180.289 82C197.62 82 211.406 86.5475 221.646 95.6426C231.887 104.666 237.008 115.193 237.008 127.225C237.008 133.885 235.11 140.187 231.314 146.131C227.59 152.075 219.57 160.167 207.252 170.408C200.878 175.708 196.904 179.969 195.328 183.191C193.824 186.414 193.144 192.179 193.287 200.486V200.486ZM165.895 241.092V210.906H196.08V241.092H165.895Z",
    fill: "#6C4BC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 361.01,
    height: 304.01,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.113f1953041e6d594b526b41172b00e2.svg";
export { ForwardRef as ReactComponent };